import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const CustomDropzone = ({ onSubmit, onError, disabled }) => {
  const [file, setFile] = useState(null);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (validateFile(acceptedFiles[0])) {
        setFile(acceptedFiles[0]);
        onSubmit(acceptedFiles[0]);
      } else {
        onError(`File is not a valid file type. Invalid type: ${acceptedFiles[0].type}`);
      }
    }
  });

  const validateFile = (file) => {
    const validTypes = ['text/csv'];
    if (validTypes.includes(file?.type)) return true;
    return false;
  }

  return (
    <>
    <h3>Recipients List</h3>
    <CentredContainer {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledInput
        type='text'
        onClick={() => {
          const fileInput = document.querySelector('input[type=file]');
          if (fileInput) fileInput.click();
        }}
        value={file ? file.name : ''}
        placeholder='Upload CSV file'
        readOnly
        disabled={disabled}
      />
    </CentredContainer>
    </>
  );
};

const CentredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInput = styled.input`
  text-align: center;
  cursor: pointer;
  border: none;
  width: 100%;
  height: 50px;
  background: #EFEFEF;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 900;
  position: relative;
  padding-left: 30px;
`;

export default CustomDropzone;
